import React,{Component}from 'react';
import axios from 'axios';
import cookie from 'react-cookies';
import { Form, FormGroup, FormControl, ControlLabel, ButtonGroup, ButtonToolbar, Button, Schema } from 'rsuite';
import CtrlPanel from './CtrlPanel';
import LoginModal from './loginModal'
import {baseUrl} from '../url'
axios.defaults.withCredentials = true;
const { StringType, NumberType } = Schema.Types;
const URL =baseUrl;
const userModel = Schema.Model({
    //UserName: NumberType("只能是数字").isRequired('账号不能为空').isInteger('只能是数字'),
    SchoolNum: NumberType("只能是数字").isRequired('账号不能为空').isInteger('只能是数字'),
    Password: StringType().isRequired('密码不能为空')
});
const buttonStyle={
    borderBottomLeftRadius: '0px',
    borderTopLeftRadius: '0px',
    borderBottomRightRadius: '0PX',
    borderTopRightRadius: '0PX',
    padding:'15px'
}
const labelStyle={
    backgroundColor:'#4e4e4e',
    margin: '0px',
    padding:'15px'
}
  
class MenuLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            login: false,
            role:0,
            formValue: {},
            info: {},
            userid: [],
            showPanel: false,
            homeworkTable: [],
            allhomeworkTable: [],
            allStudents: [],
            missions: [],
            allGeomodels:[]
        };
    }
    componentDidMount() {
        //console.log(cookie.load('data'));
        let id = cookie.load('data');
        //console.log(id);
        if (id !== "" && id !== null && id !== undefined) {
            this.getUserInformation(id); 
            this.getAllGeomodels();
        } 
    } 
    checkLogin = () => {
        // axios.post(
        //     URL+'/Login',
        //    this.state.formValue
        // )
        console.log(URL);
        axios({
            url:URL+'/Login',
            method:"post",
            data:this.state.formValue,
            header:{
                "Access-Control-Allow-origins":"*"
            }
        })
         .then((response) =>{
             //console.log(response);
             //console.log(response.data.data);
             if (response.data.code === 0) {
                 alert("正在登录...");
                 cookie.save('data', response.data.data.id, { path: '/',maxAge:3600*2 });
                 this.setState({
                     login: true,
                     info: response.data.data,
                     role: response.data.data.role,
                     userid: response.data.data.id
                 });
                 console.log(this.state.role);
                 //console.log("cookie done !");
                 this.getAllGeomodels();

             }
             else {
                 alert("用户不存在或密码错误！");
             }
         })
         .catch(function (error) {
           console.log(error);
         });
    }
    changeValue = (e) => {
        this.setState({
            formValue:e
        })
    }
    displayNormalUI = () => {
        if (!this.state.login) {
            return (
                <div>
                    <Form fluid model={userModel} onChange={this.changeValue} >
                        <FormGroup >
                            <ControlLabel style={labelStyle} label="SchoolNum">学号</ControlLabel>
                            <FormControl name="SchoolNum" style={buttonStyle}  />
                            <ControlLabel style={labelStyle} label="Password">密码</ControlLabel>
                            <FormControl name="Password" style={buttonStyle}  />
                            <ButtonToolbar>
                                <ButtonGroup justified>
                                    <Button
                                        appearance="primary"
                                        style={buttonStyle}
                                        type="submit"
                                        onClick={this.checkLogin}
                                        >
                                        登录
                                </Button>
                                    {/**<Button appearance="default" style={buttonStyle} onClick={this.props.onClick}>注册</Button> **/}
                                    <LoginModal buttonstyle={buttonStyle}/>
                                </ButtonGroup>
                            </ButtonToolbar>
                        </FormGroup>
                    </Form>
                    <p style={{ color: '#000000' }}>
                        暂时不对外开放注册<br />
                    体验账号：2020050201<br />
                    密码：123456<br />
                    </p>
                </div>
            );
        }
        else if (this.state.login) {
            return (
                <div>
                    <Form fluid>
                        <FormGroup >
                            <ControlLabel style={labelStyle}>{this.state.info.userName + " 用户你好"}</ControlLabel>
                            <ControlLabel style={labelStyle}>{"帐号：" + this.state.info.schoolNum}</ControlLabel>
                        </FormGroup>
                    </Form>
                    <ButtonGroup justified >
                        <Button onClick={this.logout}
                            style={buttonStyle}
                        >退出登录</Button>
                        <Button onClick={this.openPanel} appearance="primary" style={buttonStyle}>工程面板</Button>
                        <CtrlPanel
                            show={this.state.showPanel}
                            onHide={this.closePanel}
                            userid={this.state.info.id}
                            user={this.state.info.userName}
                        />
                    </ButtonGroup> 
                </div>
            );
        }
    }
    getUserInformation = (id) => {
        //console.log("id:" + this.state.userid);
        let tempurl = URL+'/api/Users/' + id;
        //console.log(tempurl);
        axios.get(tempurl).then(response => {
            this.setState({
                userid: this.state.userid.push(response.data.id),
                login: true,
                info: response.data,
                role: response.data.role
            });
            //console.log(response.data.id);
            //console.log(this.state.role);
        }).catch(err=>{alert("获取用户信息错误"+err)});
    }
    getAllGeomodels = () => {
        let tempurl = URL+'/api/Geomodels';
        axios.get(tempurl).then(response => {
            this.setState({
                allGeomodels: response.data
            });
        }).catch(reason=>alert("获取地质模型数据失败"+reason));
    }
    render(){
        return (
            <div>
                {this.displayNormalUI()}
            </div>
        )
    }
    logout = () => {
        cookie.remove("data");
        axios.post(URL+"/Logout").then(res => {
            //console.log("logouting:" + res);
        });
        this.setState({
            login: false
        });
    }

    openPanel = () => {
        this.setState({
            showPanel: true
        });
    }   
    closePanel = () => {
        this.setState({
            showPanel: false
        });
    }   
    
}

export default MenuLogin;